export default function fancyBox(){
    if (document.querySelector(".accommodations__slider")) {
        let items = document.querySelectorAll(".accommodations__slider");

        for (let i = 0; i < items.length; i++) {
            Fancybox.bind(`[data-fancybox='gallery-accommodations-${i}']`, {
                Thumbs: {
                    type: "classic",
                },
            });
        }
    }

    Fancybox.bind("[data-fancybox='gallery-home']", {
        Thumbs: {
            type: "classic",
        },
    });
   
    Fancybox.bind("[data-fancybox='gallery']", {
        Thumbs: {
            type: "classic",
        },
    });

    Fancybox.bind("[data-fancybox='maps']", {
        Thumbs: {
            type: "classic",
        },
    });

    Fancybox.bind("[data-fancybox='gallery discover']", {
        Thumbs: {
            type: "classic",
        },
    });

    Fancybox.bind("[data-fancybox^='gallery-']", {
        Thumbs: {
            type: "classic",
        },
    });

    document.querySelectorAll('.gallery-hotel').forEach((galleryEl, index) => {
        const galleryId = `gallery-${index + 1}`;
        galleryEl.querySelectorAll('a[href][data-fancybox]').forEach((link) => {
            link.setAttribute('data-fancybox', galleryId);
        });
    });
    document.querySelectorAll('.gallery-complex').forEach((galleryEl, index) => {
        const galleryId = `gallery-${index + 1}`;
        galleryEl.querySelectorAll('a[href][data-fancybox]').forEach((link) => {
            link.setAttribute('data-fancybox', galleryId);
        });
    });
}
